import { Button } from 'components/Button/Button';
import { ContentBlock } from 'components/ContentBlock/ContentBlock';
import { Formik } from 'formik';

import { Address } from 'services/person/person.types';

import usePersonProjectEventVM from './usePersonProjectEventFormVM';
import { AddressAutocomplete } from 'components/Address/Address';
import { addProjectEventSchema } from './PersonProjectEventFormSchema';
import FormErrorMessage from 'components/FormErrorMessage/FormErrorMessage';
import { PersonProjectEventFormik } from 'services/person/event/event.types';
import { Datalist } from 'components/Datalist/Datalist';
import moment from 'moment';
import { ApiFile } from 'utils/useFlowTs';
import { FileWidget } from 'components/FileUploader/FileWidget/FileWidget';
import { Loader } from 'components/Loader/Loader';
import { MultiSelect } from 'components/MultiSelect/MultiSelect';
import './PersonProjectEventForm.scss';
import TipTap from 'components/TipTap/TipTap';

export function ProjectEventForm() {
    const { users, partners, handleCreatePersonProjectEvent, isEdit, person, projectEvent, communicationTypes } = usePersonProjectEventVM();

    const EMPTY_VALUES = {
        label: '',
        communication_type: '',
        started_at: '',
        ended_at: '',
        address: {} as Address,
        observation: '',
        documents: [],
        stakeholders_list: [],
        assistants_list: [],
        partners_list: [],
        emails_list: []
    };

    const initValues = isEdit && projectEvent ? projectEvent : EMPTY_VALUES;

    if (!person || (!projectEvent && isEdit))
        return (
            <div>
                <Loader />
            </div>
        );

    return (
        <>
            <Formik
                initialValues={initValues as PersonProjectEventFormik}
                validationSchema={() => addProjectEventSchema()}
                onSubmit={async (values: PersonProjectEventFormik, { setSubmitting }) => {
                    handleCreatePersonProjectEvent(values);
                    setSubmitting(false);
                }}
            >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => {
                    return (
                        <form onSubmit={handleSubmit} className="form form-project-event">
                            {/* <FormikDebug values={values} /> */}
                            <ContentBlock title="Informations de l'évènement">
                                <div className="form-line">
                                    <div className="form-group">
                                        <label>Titre de l'évènement</label>
                                        <input
                                            type="text"
                                            name="label"
                                            placeholder="Doe"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.label}
                                            required
                                        />
                                        <FormErrorMessage field="label" />
                                    </div>
                                    <div className="form-group">
                                        <label>Type de communication</label>
                                        <Datalist
                                            list="communication_types"
                                            name="communication_type"
                                            placeholder="Sélectionner un type de communication"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.communication_type}
                                            required
                                        />
                                        <FormErrorMessage field="communication_type" />
                                    </div>
                                </div>
                                <div className="form-line">
                                    <div className="form-group">
                                        <label>Date de début</label>
                                        <input
                                            type="datetime-local"
                                            name="started_at"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={moment(values.started_at).format('YYYY-MM-DDTHH:mm')}
                                            required
                                        />
                                        <FormErrorMessage field="started_at" />
                                    </div>
                                    <div className="form-group">
                                        <label>Date de fin</label>
                                        <input
                                            type="datetime-local"
                                            name="ended_at"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={moment(values.ended_at).format('YYYY-MM-DDTHH:mm')}
                                        />
                                        <FormErrorMessage field="ended_at" />
                                    </div>
                                </div>
                                <div className="form-line">
                                    <div className="form-group">
                                        <label>Adresse</label>
                                        <AddressAutocomplete baseField="address" formValue={values.address} setValue={setFieldValue} />
                                    </div>
                                </div>
                                {/* <div className="form-line">
                                    <div className="form-group">
                                        <label>Observation</label>
                                        <textarea
                                            name="observation"
                                            value={values.observation}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            rows={6}
                                        ></textarea>
                                    </div>
                                </div> */}
                                <div className="form-line">
                                    <div className="form-group">
                                        <label>Observation</label>
                                        <div className="wysiwyg-container">
                                            <TipTap
                                                name="observation"
                                                value={values.observation}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="form-line">
                                    <div className="form-group">
                                        <label>Proche(s)</label>
                                        <MultiSelect
                                            name="stakeholders"
                                            placeholder="Selectionner des proches"
                                            labelKey={'fullname'}
                                            valueKey={'id'}
                                            values={values.stakeholders_list}
                                            update={(e: string[]) => {
                                                setFieldValue('stakeholders_list', e);
                                            }}
                                            options={person?.stakeholders ?? []}
                                            colors={[]}
                                        />
                                        <FormErrorMessage field="stakeholders" />
                                    </div>
                                    <div className="form-group">
                                        <label>Participants</label>
                                        <MultiSelect
                                            name="assistants"
                                            placeholder="Selectionner des membres DAPV"
                                            labelKey={'fullname'}
                                            valueKey={'id'}
                                            values={values.assistants_list}
                                            update={(e: string[]) => {
                                                setFieldValue('assistants_list', e);
                                            }}
                                            options={users}
                                            colors={[]}
                                        />
                                        <FormErrorMessage field="assistants" />
                                    </div>
                                </div>
                                <div className="form-line">
                                    <div className="form-group">
                                        <label>Partenaires invités</label>
                                        <MultiSelect
                                            name="partners"
                                            placeholder="Selectionner des partenaires"
                                            labelKey={'name'}
                                            valueKey={'id'}
                                            values={values.partners_list}
                                            update={(e: string[]) => {
                                                setFieldValue('partners_list', e);
                                            }}
                                            options={partners}
                                            colors={[]}
                                        />
                                        <FormErrorMessage field="partners" />
                                    </div>
                                    <div className="form-group">
                                        <label>Emails invités</label>
                                        <MultiSelect
                                            name="emails"
                                            labelKey={'label'}
                                            valueKey={'value'}
                                            placeholder="Saisir des emails"
                                            values={values.emails_list}
                                            update={(e: string[]) => {
                                                setFieldValue('emails_list', e);
                                            }}
                                            creatable={true}
                                            options={[]}
                                            colors={[]}
                                        />
                                        <FormErrorMessage field="partners" />
                                    </div>
                                </div>
                            </ContentBlock>
                            {!isEdit && (
                                <ContentBlock title="Documents">
                                    <div className="form-line">
                                        <div className="form-group">
                                            <FileWidget
                                                documents={values.documents as unknown as ApiFile[]}
                                                onAddFile={(file) => setFieldValue('documents', [...values.documents, file])}
                                                onUpdateFile={(file) =>
                                                    setFieldValue(
                                                        'documents',
                                                        values.documents.map((doc) => (doc.id === file.id ? file : doc))
                                                    )
                                                }
                                                onDeleteFile={(file) =>
                                                    setFieldValue(
                                                        'documents',
                                                        values.documents.filter((doc) => doc.id !== file.id)
                                                    )
                                                }
                                            />
                                        </div>
                                    </div>
                                </ContentBlock>
                            )}
                            <Button type="submit" label={isEdit ? "Modifier l'évènement" : "Ajouter l'évènement"} />
                        </form>
                    );
                }}
            </Formik>
        </>
    );
}
